<template>
  <div class='h100vh-150 h-normalBg'>
    <div class='h-normalContainter'>
      <div class='row h-chart-titleBg h-nomargin'>
        <!-- <div class='col-sm-1'></div> -->
        <div class='col-sm-3 h-chart-titleText'>{{ option.charTitle }}</div>
        <div class='col-sm-3 h-chart-selectText'>
           <button class="e-control e-btn e-lib e-primary e-flat" data-ripple="true" @click='getTodayDate'   >{{$t('Alarm.thisDay')}}</button>
          <span>   </span>
          <button  @click='getWeekDate'  class="e-control e-btn e-lib e-primary e-flat" data-ripple="true">{{$t('Alarm.thisWeek')}}</button >
          <span>   </span> 
          <button  @click='getMonthDate'  class="e-control e-btn e-lib e-primary e-flat" data-ripple="true" >{{$t('Alarm.thisMonth')}}</button >
          <span>   </span>
          <button  @click='getYearDate' class="e-control e-btn e-lib e-primary e-flat" data-ripple="true" >{{$t('Alarm.thisYear')}}</button >
        </div>
        <div class='col-sm-3 '>
          <div class='col-sm-3 h-chart-datetimepickerText'><span>{{$t('Alarm.notifystart')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker'>
            <ejs-datetimepicker :format='dateFormat' :step='60' :locale='locale'　timeFormat='HH:mm:ss' :value='startDateValue' :change='changeStart'></ejs-datetimepicker>
          </div>
        </div>
        <div class='col-sm-3 '>
          <div class='col-sm-3 h-chart-datetimepickerText'><span>{{$t('Alarm.notifyend')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker'>
            <ejs-datetimepicker :format='dateFormat' :step='60' :locale='locale'　timeFormat='HH:mm:ss' :value='endDateValue' :change='changeEnd'></ejs-datetimepicker>
          </div>
        </div>
      </div>
      <div class='row h-nomargin h-full-container width-100vw h100-80'>
        <div id='myChart' class='width-100vw h100'></div>
      </div>
    </div>
  </div>
</template>
<script>
const echarts = require('echarts');

const now = new Date();
let nowDayOfWeek = now.getDay();
if (nowDayOfWeek === 0) {
  nowDayOfWeek = 6;
} else {
  nowDayOfWeek -= 1;
}
const nowDay = now.getDate();
const nowMonth = now.getMonth();
let nowYear = now.getYear();
nowYear += (nowYear < 2000) ? 1900 : 0;

export default {
  name: 'StaticsChar',
  props: {
    url: { type: String, default: '' },
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    },
    option: {
      type: Object,
      default() {
        return {
          charTitle: '',
          allNumTitle: ''
        };
      }
    }
  },
  data() {
    return {
      myChart: null,
      locale: localStorage.getItem('locale'),
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      queryConditions: {
        systemId: '1',
        startTime: '',
        endTime: ''
      },
      charSetting: {
        seriesName: [
          `${this.$t('Alarm.alarmLevel_0')}(${this.$t('Alarm.singleNetwork')})`,
          `${this.$t('Alarm.alarmLevel_1')}(${this.$t('Alarm.singleNetwork')})`,
          `${this.$t('Alarm.alarmLevel_2')}(${this.$t('Alarm.singleNetwork')})`,
          `${this.$t('Alarm.alarmLevel_3')}(${this.$t('Alarm.singleNetwork')})`,
          `${this.option.allNumTitle}(${this.$t('Alarm.singleNetwork')})`
        ],
        seriesColor: ['#ff0000', '#ff8000', '#facc14', '#13c2c2', '#29aa4f']
      },
      charDatas: {
        allList: [0, 0, 0, 0],
        criticalList: [],
        majorList: [],
        minorList: [],
        warningList: [],
        sumList: [],
        neList: [],
        endTime: '',
        startTime: '',
        result: true
      }
    };
  },
  computed: {
    startDateValue() {
      const dateRange = this.queryConditions.startTime ? `${this.getDate(this.queryConditions.startTime)}` : '';
      return dateRange;
    },
    endDateValue() {
      const dateRange = this.queryConditions.endTime ? `${this.getDate(this.queryConditions.endTime)}` : '';
      return dateRange;
    },
    getSeriesData() {
      const seriesData = [];
      for (let i = 0; i < this.charDatas.neList.length; i++) {
        seriesData.push({
          ne: this.charDatas.neList[i],
          critical: this.charDatas.criticalList[i],
          major: this.charDatas.majorList[i],
          minor: this.charDatas.minorList[i],
          warning: this.charDatas.warningList[i],
          sum: this.charDatas.sumList[i]
        });
      }
      return seriesData;
    }
  },
  watch: {
    roleNe() {
      this.getStatisData();
    }
  },
  methods: {
    getDate(date) {
      return this.turnToFormateDate(new Date(date));
    },
    turnToFormateDate(dateValue) {
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let hour = dateValue.getHours();
      if (hour < 10) {
        hour = `0${hour}`;
      }
      let minutes = dateValue.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      let sec = dateValue.getSeconds();
      if (sec < 10) {
        sec = `0${sec}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day} ${hour}:${minutes}:${sec}`;
    },
    getMonthDays(month) {
      const monthStartDate = new Date(nowYear, month, 1);
      const monthEndDate = new Date(nowYear, month + 1, 1);
      const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    },
    getTodayDate() {
      this.queryConditions.startTime = new Date(nowYear, nowMonth, nowDay, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, nowMonth, nowDay, 23, 59, 59).getTime();
    },
    getWeekDate() {
      this.queryConditions.startTime = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek), 23, 59, 59).getTime();
    },
    getMonthDate() {
      this.queryConditions.startTime = new Date(nowYear, nowMonth, 1, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth), 23, 59, 59).getTime();
    },
    getYearDate() {
      this.queryConditions.startTime = new Date(nowYear, 0, 1, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, 11, 31, 23, 59, 59).getTime();
    },
    changeStart(args) {
      this.queryConditions.startTime = new Date(args.value).getTime();
      this.getStatisData();
    },
    changeEnd(args) {
      this.queryConditions.endTime = new Date(args.value).getTime();
      this.getStatisData();
    },
    getChartOption() {
      let endStr = 100;
      if (this.charDatas.neList.length > 15) {
        endStr = parseInt(15 / this.charDatas.neList.length * 100, 10);
      }
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'middle',
          itemGap: 40,
          itemWidth: 22,
          itemHeight: 12,
          textStyle: {
            padding: [0, 0, 0, 25]
          }
        },
        grid: {
          left: '5%',
          right: '18%',
          top: '5%',
          bottom: '12%',
          containLabel: true
        },
        dataZoom: {
          show: true,
          start: 0,
          end: endStr,
          y: '90%'
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#d9d9d9'
            }
          },
          axisTick: {
            alignWithLabel: true,
            interval: 0,
            length: 9
          },
          axisLabel: {
            margin: 20,
            color: '#5a5a5a'
          },
          data: this.charDatas.neList
        }],
        yAxis: [{
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            margin: 20,
            color: '#5a5a5a'
          },
          splitLine: {
            lineStyle: {
              color: '#e8e8e8',
              type: 'dashed'
            }
          }
        }],
        color: this.charSetting.seriesColor,
        series: [{
          name: this.charSetting.seriesName[0],
          type: 'bar',
          stack: 'ne-name',
          barWidth: '50%',
          data: this.charDatas.criticalList
        }, {
          name: this.charSetting.seriesName[1],
          type: 'bar',
          stack: 'ne-name',
          barWidth: '50%',
          data: this.charDatas.majorList
        }, {
          name: this.charSetting.seriesName[2],
          type: 'bar',
          stack: 'ne-name',
          barWidth: '50%',
          data: this.charDatas.minorList
        }, {
          name: this.charSetting.seriesName[3],
          type: 'bar',
          stack: 'ne-name',
          barWidth: '50%',
          data: this.charDatas.warningList
        }, {
          name: this.charSetting.seriesName[4],
          type: 'line',
          symbol: 'circle',
          symbolSize: 5,
          data: this.charDatas.sumList
        }]
      };
      return option;
    },
    init() {
      this.myChart = echarts.init(document.getElementById('myChart'));
      this.getWeekDate();
    },
    getStatisData() {
      this.myChart.showLoading({
        text: '',
      });
      this.$axios.post(this.url, {
        startTime: this.queryConditions.startTime,
        endTime: this.queryConditions.endTime,
        roleNe: this.roleNe
      }).then((response) => {
        this.myChart.hideLoading();
        if (response && response.status === 200) {
          this.charDatas = response.data.resultVal;
          this.myChart.clear();
          this.myChart.setOption(this.getChartOption(), true);
          this.myChart.resize();
        }
      });
    },
    resize() {
      this.myChart.resize();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style>
  #container {
    height: 700px;
  }
</style>
